module.exports = __webpack_public_path__ + "img/arrow_back.53d12838.svg";